import * as Dialog from '@radix-ui/react-dialog';
import { Button } from 'components/ui/button';
import { X } from 'lucide-react';
import { useState } from 'react';
import SaveDialog from './SaveDialog';

interface SaveRequiredModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  postTitle: string;
  setPostTitle: (title: string) => void;
  platformName: string;
}

export default function SaveRequiredModal({
  isOpen,
  onOpenChange,
  postTitle,
  setPostTitle,
  platformName
}: SaveRequiredModalProps) {
  const [showSaveDialog, setShowSaveDialog] = useState(false);

  return (
    <>
      <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 bg-black/50" />
          <Dialog.Content className="fixed text-text-primary bg-background left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] rounded-lg p-6 shadow-lg w-[400px] max-w-[calc(100%-32px)]">
            <div className="flex flex-col gap-4">
              <div className="flex justify-between items-start">
                <Dialog.Title className="text-2xl font-bold">
                  Save Required
                </Dialog.Title>
                <Dialog.Close asChild>
                  <button className="rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2">
                    <X className="h-4 w-4" />
                    <span className="sr-only">Close</span>
                  </button>
                </Dialog.Close>
              </div>
              <p>
                Please save your post before publishing. This helps you keep track of your content.
              </p>
              <div className="flex justify-end gap-2 mt-2">
                <Button
                  type="button"
                  onClick={() => onOpenChange(false)}
                  variant={'customSecondary'}
                  size={'sm'}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  onClick={() => {
                    onOpenChange(false);
                    setShowSaveDialog(true);
                  }}
                  variant={'customPrimary'}
                  size={'sm'}
                >
                  Save Now
                </Button>
              </div>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>

      <SaveDialog
        isSaveDialogOpen={showSaveDialog}
        setIsSaveDialogOpen={setShowSaveDialog}
        postTitle={postTitle}
        setPostTitle={setPostTitle}
        platformName={platformName}
      />
    </>
  );
} 